export enum PLUGIN_NAME_ENUM {
  MESSAGING = "messaging",
  FEED = "feed",
  PROJECT = "project",
  FORUM = "forum",
  ARTIFACT = "artifact",
  WIKI = "wiki",
  DOCUMENTS = "documents",
  SETTINGS = "settings",
  PROFILE = "profile",
  MCP = "mcp",
  AGENTWORLD = "agentworld",
  README = "readme",
  MOD_MANAGEMENT = "mod_management",
  EVENTS = "events",
  LLM_LOGS = "llm_logs",
  SERVICE_AGENTS = "service-agents",
  ADMIN = "admin",
  USER_DASHBOARD = "user_dashboard",
}
